export interface SalesDespatchItemInvoice {
  salesDespatchNoteId: string;
  despatchNoteNo: number;
  despatchDate: Date;
  salesInvoiceStatus: string;
  packNo: number;
  noOfItems: number;
  stockNo: string;
  productKey: string;
  productDescription: string;
  invoicePrice: number;
  freeOfChargeQty: number;
  grossQuantity: number;
  nettQuantity: number;
  orderNo: string;
  selected: boolean;
  canDelete: boolean;
}
